import clsx from 'clsx'

import getInitials from '../../app/utils/getInitials'

import styles from './ProfileAvatar.module.scss'

type ProfileAvatarProps = {
  name: string | null | undefined
  isCompany?: boolean
  size?: 'small' | 'medium' | 'large'
  className?: string
}

/** Initials of a profile, company profiles in the company accent */
export default function ProfileAvatar({
  name,
  isCompany = false,
  size = 'medium',
  className,
}: ProfileAvatarProps) {
  return (
    <span
      className={clsx(
        styles.avatar,
        {
          [styles.company]: isCompany,
          [styles.small]: size === 'small',
          [styles.large]: size === 'large',
        },
        className,
      )}
      aria-hidden
    >
      {getInitials(name)}
    </span>
  )
}
